import * as React from 'react';
import { useHits } from 'react-instantsearch';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, XAxis, YAxis, Tooltip, Label } from 'recharts';
import NvChartTooltip from "./NvChartTooltip";
import { buildData, Config } from "../helpers";
import { LinesPreloader } from "./Preloader";

export default function NvChartHitsWidget(props) {
  const {
    chartConfig,
    lineStyle = Config.Styles.Chart.DefaultLineStyle
  } = props;

  const [chartData, setChartData] = React.useState([]);
  const [chartGroups, setChartGroups] = React.useState([]);

  const hitsData = useHits(props);
  const {items} = hitsData;

  React.useEffect(() => {
    const {data, groups} = buildData(items, chartConfig);
    setChartData(data);
    setChartGroups(groups);
  }, [items]);

  if (chartData.length === 0 || chartGroups.length === 0) {
    return <LinesPreloader/>
  }

  const tickFormatter = (value, format) => value;

  const colorsMap = {};
  chartConfig.colorsMap.forEach(entry => {
    colorsMap[entry.id] = entry.color;
  });

  return (
    <div>
      <ResponsiveContainer width={Config.Styles.Chart.Width} height={Config.Styles.Chart.Height}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3"/>
          <XAxis
            tickFormatter={(value) => tickFormatter(value, chartConfig.axes.x.format)}
            dataKey={chartConfig.axes.x.field}
            tick={Config.Styles.Chart.Axis.Tick}
            axisLine={Config.Styles.Chart.Axis.AxisLine}>
            <Label value={chartConfig.axes.x.label} position="bottom" offset={0}/>
          </XAxis>
          <YAxis
            tickFormatter={(value) => tickFormatter(value, chartConfig.axes.y.format)}
            tick={Config.Styles.Chart.Axis.Tick}
            axisLine={Config.Styles.Chart.Axis.AxisLine}>
            <Label value={chartConfig.axes.y.label} angle={-90} position="inside" dx={-20}/>
          </YAxis>
          <Tooltip content={<NvChartTooltip chartConfig={chartConfig}/>}/>
          <Legend/>

          {chartGroups.map((g, idx) => {
            const gid = g.id.toLowerCase();

            let color = "#000";
            Object.entries(colorsMap).forEach(val => {
              const [k, v] = val;
              if(gid.startsWith(k.toLowerCase())) {
                color = v;
              }
            });

            return (
              <Line
                key={g.id}
                dataKey={g.id}
                name={g.label}
                connectNulls={true}
                type={lineStyle}
                strokeWidth={2}
                stroke={color}
              />
            );
          })}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
